var React = require('react');

function ArrowForward (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.1689 8.79624C16.7784 9.18673 16.7783 9.8199 17.1688 10.2105L21.9599 15.0024H8.62495C8.07267 15.0024 7.62495 15.4502 7.62495 16.0024C7.62495 16.5547 8.07267 17.0024 8.62495 17.0024H21.9596L17.1689 21.7931C16.7783 22.1837 16.7783 22.8168 17.1689 23.2074C17.5594 23.5979 18.1926 23.5979 18.5831 23.2074L25.0809 16.7096C25.4714 16.3191 25.4714 15.6859 25.081 15.2954L18.5831 8.79638C18.1927 8.40582 17.5595 8.40576 17.1689 8.79624Z","fill":"currentColor"}));
}

ArrowForward.defaultProps = {"width":"33","height":"32","viewBox":"0 0 33 32","fill":"none"};

module.exports = ArrowForward;

ArrowForward.default = ArrowForward;
